import { Box } from '@factorialco/deprecated-design-system'
import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import AutoScheduleButton from 'modules/shift_management/components/ShiftManagement/Content/TableHeader/ShiftActionsBar/AutoScheduleButton'
import Publish from 'modules/shift_management/components/ShiftManagement/Layout/Actions/Publish'
import { Separator } from 'modules/shift_management/components/ShiftManagement/Separator'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'

import AddShiftButton from './AddShiftButton'
import ClearSelectionButton from './ClearSelectionButton'
import CopyPeriodButton from './CopyPeriodButton'
import CopyShiftButton from './CopyShiftButton'
import DeleteButton from './DeleteButton'
import EditShiftsButton from './EditShiftButton'

interface Props {
  hasNoneShiftManagementPlanning?: boolean
  hasTimeOffModule: boolean
}

const ShiftActionsBar = ({ hasNoneShiftManagementPlanning, hasTimeOffModule }: Props) => {
  const [{ view }] = useSchedule()
  const { isEnabled: isSelectionEnabled, shifts: selectedShifts, kind } = useSelectionState()
  const [{ canUseCopySchedulePeriod }] = useEnabledFeatures()
  const shifts = Object.values(selectedShifts)
  const canEditSelectedShifts = !isEmpty(shifts) && kind !== 'all'

  return (
    <Box flexDirection="row" alignItems="center" gap="s8" flexWrap="wrap">
      {!isSelectionEnabled && view.isWeekly && !canUseCopySchedulePeriod && (
        <CopyShiftButton disabled={hasNoneShiftManagementPlanning} />
      )}
      {isSelectionEnabled && canEditSelectedShifts && <EditShiftsButton />}
      {isSelectionEnabled && <ClearSelectionButton />}
      {isSelectionEnabled && <Separator />}
      <AddShiftButton
        disabled={hasNoneShiftManagementPlanning}
        hasTimeOffModule={hasTimeOffModule}
      />
      {canUseCopySchedulePeriod && <CopyPeriodButton disabled={hasNoneShiftManagementPlanning} />}
      <DeleteButton disabled={hasNoneShiftManagementPlanning} />
      <Separator />
      <AutoScheduleButton />
      <Publish />
    </Box>
  )
}

export default observer(ShiftActionsBar)
